/**
 * Los iconos que usan los componentes de la capa, en su talla de control (14; otra se pasa por
 * props). Son un subconjunto de `src/au/icons/`, la única fuente del dibujo, no una copia.
 */
import {
  IconAlert as BaseAlert,
  IconCheck as BaseCheck,
  IconCheckCircle as BaseCheckCircle,
  IconChevron,
  IconClose as BaseClose,
  IconCloseCircle as BaseCloseCircle,
  IconInfo as BaseInfo,
  IconMinus as BaseMinus,
  IconPlus as BasePlus,
  type IconProps,
} from '../icons'

const SIZE = 14

export function IconCheck(props: IconProps) {
  return <BaseCheck size={SIZE} {...props} />
}

export function IconMinus(props: IconProps) {
  return <BaseMinus size={SIZE} {...props} />
}

export function IconPlus(props: IconProps) {
  return <BasePlus size={SIZE} {...props} />
}

export function IconChevronDown(props: IconProps) {
  return <IconChevron facing="down" size={SIZE} {...props} />
}

export function IconChevronUp(props: IconProps) {
  return <IconChevron facing="up" size={SIZE} {...props} />
}

export function IconChevronRight(props: IconProps) {
  return <IconChevron facing="right" size={SIZE} {...props} />
}

export function IconClose(props: IconProps) {
  return <BaseClose size={SIZE} {...props} />
}

export function IconAlert(props: IconProps) {
  return <BaseAlert size={SIZE} {...props} />
}

export function IconInfo(props: IconProps) {
  return <BaseInfo size={SIZE} {...props} />
}

export function IconCheckCircle(props: IconProps) {
  return <BaseCheckCircle size={SIZE} {...props} />
}

export function IconCloseCircle(props: IconProps) {
  return <BaseCloseCircle size={SIZE} {...props} />
}
